// Rotulos e formatacao de marketplace reusados pelo painel (Links e Vitrine),
// evitando duplicar o mapa de labels em cada tela.

const MARKETPLACE_LABELS: Record<string, string> = {
  amazon: "Amazon",
  mercadolivre: "Mercado Livre",
  shopee: "Shopee",
  aliexpress: "AliExpress",
  magalu: "Magalu",
  awin: "AWIN",
  shein: "SHEIN",
  rakuten: "Rakuten",
  custom: "Link avulso",
};

/** Nome amigavel do marketplace a partir do codigo interno. */
export function marketplaceLabel(code: string): string {
  return MARKETPLACE_LABELS[code] ?? code;
}

/** Formata centavos em reais (pt-BR). Retorna null quando nao ha snapshot. */
export function formatPriceCents(priceCents: number | null): string | null {
  if (priceCents === null) return null;

  return (priceCents / 100).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
